import axios from "axios"
import getaccessToken from "./jwt-token-access/accessToken"

import { isLocalhost } from "../utils/utilerias"

//pass new generated access token here
//const token = getaccessToken()

//apply base url for axios
const API_URL = isLocalhost
  ? "http://localhost:56899"
  : "https://campusvirtualapi-beta.azurewebsites.net"
//const API_URL = "https://campusvirtualapi-beta.azurewebsites.net"
const API_REFRESH_TOKEN = "/api/authenticate/refresh-token"
// const alumnos = [
//   {
//     id_Alumno: 1,
//     apellidopaterno_apellido_materno_nombre: "ACOSTA ZENDEJAS JUAN EDUARDO",
//     Nombre_Turno: "Sabatino",
//     Nombre_Status: "Activo",
//     Balance: 250.0,
//     Promedio: 9.01,
//     Avance: "32/41",
//   },
// ]

const axiosApi = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json", // Solo aceptar respuestas JSON
  },
})

// Interceptor que pone el Bearer Authoritation
axiosApi.interceptors.request.use(function (config) {
  const accessToken = getaccessToken()
  config.headers.Authorization = accessToken ? `Bearer ${accessToken}` : ""
  return config
})

// Interceptor de AccessToken y RefreshToken
// Los graba en localStorage
axiosApi.interceptors.response.use(
  response => {
    //console.log("axiosApi.interceptors.response.use:: newAccessToken")
    // Verificar si los encabezados Token y RefreshToken están presentes
    const newAccessToken = response.headers.token

    //console.log("headers: ", response.headers)
    //console.log("newAccessToken: ", newAccessToken)

    // Guardar en localStorage si están presentes
    if (newAccessToken) {
      localStorage.setItem("accessToken", newAccessToken)
      //console.log("Nuevo Access Token almacenado.")

      const newRefreshToken = response.data?.RefreshToken
      //console.log(response?.data)
      if (newRefreshToken) {
        localStorage.setItem("refreshToken", newRefreshToken)
        //console.log("Nuevo Refresh Token almacenado.")
      }
    }
    return response // Retornar la respuesta al flujo original
  },
  error => {
    // Manejo de errores
    return Promise.reject(error)
  }
)

// Interceptor por si hay un error 401
axiosApi.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config
    //console.log("interceptors: ", error.config)

    // Verificar si el error es por un token expirado y no hemos reintentado ya
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true // Marcar para evitar un bucle infinito

      try {
        // Obtener el Refresh Token almacenado
        const refreshToken = localStorage.getItem("refreshToken")

        // Solicitar un nuevo Access Token y Refresh Token
        const refreshResponse = await axios.post(API_URL + API_REFRESH_TOKEN, {
          refreshToken: refreshToken,
        })

        // Recuperar los nuevos tokens de los headers
        const newAccessToken = refreshResponse.headers.token
        const newRefreshToken = refreshResponse.data.RefreshToken

        // Guardar los nuevos tokens en el almacenamiento local
        localStorage.setItem("accessToken", newAccessToken)
        localStorage.setItem("refreshToken", newRefreshToken)

        // Clonar y actualizar encabezados en la solicitud original
        originalRequest.headers = {
          ...originalRequest.headers, // Copiar encabezados originales
          Authorization: `Bearer ${newAccessToken}`, // Actualizar token de acceso
        }

        const respuesta = await axiosApi(originalRequest).then(response => {
          try {
            return JSON.parse(response.data)
          } catch (e) {}
          return response.data
        })

        // Retornar una promesa resuelta con "alumnos"
        return Promise.resolve({
          data: respuesta,
        })
      } catch (refreshError) {
        console.error("Error al refrescar el token:", refreshError)
        // Opcional: Redirigir al usuario a la página de inicio de sesión
        window.location.href = "/login"
      }
    }

    // Si no es un error 401 o no se pudo refrescar el token, continuar con el error
    return Promise.reject(error)
  }
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return await axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}

export async function postFormData(
  url,
  data,
  config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
) {
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

// export async function postFormDataworking(
//   url,
//   formData,
//   config = {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   }
// ) {
//   return await axiosApi
//     .post(url, formData, { ...config })
//     .then(response => response.data)
// }
